import React from 'react';

const Demo = () => {
  return (
    <section className='demo_sect'>
      <div className='wrapper'>
        <p>
          You are logged in using demo. Some details may be hidden, and
          functions disabled. <br />
          (This message disappears in 8 secs)
        </p>
      </div>
    </section>
  );
};

export default Demo;
